export default "__VITE_ASSET__D0eoWo7C__"